import React from 'react';
import { Box, Image, Input } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

const SearchInput = () => {
  return (
    <Input
      icon={<IconSearch />}
      placeholder="Search user..."
      styles={(theme) => ({
        input: {
         
            minHeight: '50px',
            minWidth: '438px',
        },
      })}
    />
  );
};

export default SearchInput;
